import DeliveryOrderingDetailsSFC from "./DeliveryOrderingDetails.vue";
export const DeliveryOrderingDetails = DeliveryOrderingDetailsSFC;
